import { connect } from "react-redux";

import { RootState } from "@app/store/rootReducer";

import EditNotesPanel from "../../components/EditNotesPanel";
import { createPersonNote, deletePersonNote, updatePersonNote } from "../store/actions";
import {
  getPersonNoteDeleteLoadingIds,
  getPersonNoteUpdateLoadingIds,
  isPersonNoteCreateLoading,
} from "../store/selectors";

const mapStateToProps = (state: RootState) => ({
  createLoading: isPersonNoteCreateLoading(state),
  deleteLoadingIds: getPersonNoteDeleteLoadingIds(state),
  updateLoadingIds: getPersonNoteUpdateLoadingIds(state),
});

const mapDispatchToProps = {
  onChangeNote: updatePersonNote.request,
  onCreateNote: createPersonNote.request,
  onDeleteNote: deletePersonNote.request,
};

const Notes = connect(mapStateToProps, mapDispatchToProps)(EditNotesPanel);
export default Notes;
